import { css } from '@emotion/core';
import { tokens, media } from '@domain-group/fe-brary';
import { designTokenFonts } from '@domain-group/fe-co-allhomes-design-system';
var colors = tokens.colors;
export var row = {
  name: "1qm1lh",
  styles: "margin-bottom:16px;"
};
export var resultsHeading = /*#__PURE__*/css("margin-bottom:8px;color:", colors.neutral.heavy.default, ";", designTokenFonts.heading);
export var resultSubheading = /*#__PURE__*/css("color:", colors.neutral.heavy.default, ";", designTokenFonts.body, " padding-bottom:10px;");
export var listingsListContainer = {
  name: "1pdwn0x",
  styles: "background-color:#fff;padding:32px 0;margin:32px 0;"
};
export var items = {
  name: "13o6z6d",
  styles: "margin:0 auto;"
};
export var item = /*#__PURE__*/css("margin:0 auto;", media('>=tablet', '<desktop'), "{max-width:722px;}");